import { FC, useEffect, useRef } from 'react';

import { CheckCircleIcon, MailIcon } from '@heroicons/react/outline';

import CouponProductCard from './CouponProductCard';
import SendScheduleCard from './SendScheduleCard';

interface SubmitSuccessViewProps {
  redeemSubmitMeta: { submittedAt: Date; expectedSendAt: Date } | null;
  imageUrl: string;
  itemName: string;
  couponCode: string;
  brandName: string | null;
  selectedUnit: { name: string; image?: { url?: string } } | null;
}

const SubmitSuccessView: FC<SubmitSuccessViewProps> = ({
  redeemSubmitMeta,
  imageUrl,
  itemName,
  couponCode,
  brandName,
  selectedUnit,
}) => {
  const scheduleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const timer = setTimeout(() => {
      scheduleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 600);

    return () => clearTimeout(timer);
  }, []);

  return (
  <div className="min-h-screen bg-gradient-to-b from-stone-100 to-white px-4 py-8">
    <div className="mx-auto max-w-md">
      <div className="rounded-xl border border-stone-200 bg-stone-50 p-6 text-center">
        <CheckCircleIcon className="mx-auto h-10 w-10 text-stone-500" />
        <h2 className="mt-3 text-lg font-medium text-stone-800">신청이 완료되었습니다</h2>
        <p className="mt-1 whitespace-pre-line text-sm text-stone-500">
          {'입력하신 번호로 곧 전송됩니다.\n잠시만 기다려 주세요.\n\n영업일 기준 10시, 14시, 18시에 발송됩니다.\n발송까지 30분~1시간 소요될 수 있습니다.\n(주말 및 공휴일 제외, 익영업일 기준)'}
        </p>
      </div>

      {redeemSubmitMeta && (
        <div ref={scheduleRef} className="animate-highlight-pulse">
          <SendScheduleCard
            requestedAt={redeemSubmitMeta.submittedAt}
            expectedSendAt={redeemSubmitMeta.expectedSendAt}
          />
        </div>
      )}

      <CouponProductCard
        imageUrl={imageUrl}
        itemName={itemName}
        couponCode={couponCode}
        brandName={brandName}
        selectedUnit={selectedUnit}
      />

      <div className="mt-6 text-center">
        <a
          href="mailto:smartnanumi@kakao.com"
          className="inline-flex items-center gap-1 text-xs text-stone-300 transition hover:text-stone-400"
        >
          <MailIcon className="h-3 w-3" />
          <span>문의 smartnanumi@kakao.com</span>
        </a>
      </div>
    </div>
  </div>
  );
};

export default SubmitSuccessView;
